export const Markets = [
    {
        label: 'All Markets',
        value: 'all',
    },
];
